$(function() {
	$(document).on('mouseenter', '.rating-wrapper .rating-star', function() {
		if ($(this).hasClass('disabled')) return;
		$(this).addClass('hover hover-current').prevAll().addClass('hover');
		$(this).parent().find('.rating-total').text($(this).data('rating'));
	});

	$(document).on('mouseleave', '.rating-wrapper .rating-star', function() {
		if ($(this).hasClass('disabled')) return;
		$(this).removeClass('hover hover-current').prevAll().removeClass('hover');
		$(this).parent().find('.rating-total').text($(this).parent().find('input').val());
	});

	$(document).on('click init.rating', '.rating-wrapper .rating-star', function(e) {
		if (e.type !== 'init' && $(this).hasClass('disabled')) return;
		$(this).siblings().removeClass('active active-current');
		$(this).addClass('active active-current').prevAll().addClass('active');
		$(this).parent().find('input').val($(this).data('rating'));
		$(this).parent().find('.rating-total').text($(this).data('rating'));
	});

	$('.rating').each(function() {
		var $input   = $(this);
		var $wrapper = $('<div class="rating-wrapper form-control-static" />');
		var max      = $input.attr('max') || 5;
		var disabled = $input.prop('disabled');

		$wrapper.insertAfter($input);
		$input.appendTo($wrapper).addClass('d-none');

		for (var i = 1; i <= max; i++) {
			$wrapper.append('<span class="rating-star ' + (disabled ? 'disabled' : '') + '" data-rating="' + i + '" />');
		}

		$wrapper.append('<span class="rating-total" />');
		$wrapper.find('[data-rating="' + $input.val() + '"]').trigger('init.rating');
	});
});
